<template>
  <div class="row">
    <div class="col-md-12 pt-0 pb-0">
      <h6>
        <span class="text-muted">SERVIÇO:</span>
        {{ service.service_description }}
      </h6>
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <h6>
        <span class="text-muted">QUANTIDADE:</span> {{ service.quantity }}
      </h6>
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <h6>
        <span class="text-muted">DATA DO SERVIÇO:</span>
        {{ moment(service.date).format("DD/MM/YYYY") }}
      </h6>
    </div>
    <div class="col-md-12 v-warning">
      <p class="m-0 text-center">
        APÓS GERAR A MOVIMENTAÇÃO, NÃO SERÁ POSSÍVEL EXCLUIR OU EDITAR O
        LANÇAMENTO!
      </p>
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-12 text-center">
      <v-btn-save
        class="btn-block"
        :disabled="loading"
        :loading="loading"
        text="GERAR MOVIMENTAÇÃO"
        @click="execute"
      />
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages.vue";

import VBtnSave from "../../../../Components/VBtnSave.vue";

import api from "../../../../../services/api";

import toast from "../../../../../lib/ToastNotification";

import moment from "moment";

export default {
  name: "Status",

  components: {
    ErrorsMessages,
    VBtnSave,
  },

  props: {
    service: Object,
  },

  data() {
    return {
      loading: false,

      errors: [],
    };
  },

  created() {},

  methods: {
    moment,

    async execute() {
      try {
        this.loading = true;

        const {
          service: { id },
        } = this;

        let params = { id };

        const response = await api.put("/rest-home/resident/service", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("status");
          toast(message, "success");
          this.$emit("success");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
